import Repository from '@/libs/axios'

const configurationResource = '/admin/merchant/registration-form/configuration'
const merchantRegistrationSettingsResource = '/admin/settings/merchant-registration'

export default {
  getConfiguration() {
    return Repository.get(`${configurationResource}`)
  },
  saveConfiguration(configuration) {
    return Repository.put(`${configurationResource}`, configuration)
  },
  getMerchantRegistrationSettings() {
    return Repository.get(`${merchantRegistrationSettingsResource}`)
  },
  updateMerchantRegistrationSettings(payload) {
    return Repository.put(`${merchantRegistrationSettingsResource}`, payload)
  },
}
